import api from '../../plugins/api';

const getContainers = (params) => {
  return api.get('/api/shop/getContainers', params);
};

export default getContainers;
